import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

/** Toolbar above a table/list – a quiet row, no box: search + filters (left), count + extras (right). */
export const Toolbar = ({ search, onSearch, searchPlaceholder = "Søk…", count, countLabel = "treff", children, right, className, testId = "admin-toolbar", searchTestId = "admin-table-search-input" }) => (
  <div className={cn("mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between", className)} data-testid={testId}>
    <div className="flex min-w-0 flex-1 flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center">
      {onSearch && (
        <div className="relative sm:w-[260px]">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" aria-hidden="true" />
          <Input value={search || ""} onChange={(e) => onSearch(e.target.value)} placeholder={searchPlaceholder} aria-label={searchPlaceholder} className="h-9 rounded-lg border-border bg-card pl-9 pr-9 text-[13.5px]" data-testid={searchTestId} />
          {search && <button type="button" onClick={() => onSearch("")} className="absolute right-1.5 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-md text-muted-foreground hover:bg-secondary hover:text-foreground" aria-label="Tøm søk" data-testid={`${searchTestId}-clear`}><X className="h-3.5 w-3.5" /></button>}
        </div>
      )}
      {children}
    </div>
    {(count !== undefined || right) && (
      <div className="flex items-center justify-between gap-3 text-[13px] text-muted-foreground sm:justify-end">
        {count !== undefined && <span className="tabular" data-testid="admin-toolbar-count" aria-live="polite">{count} {countLabel}</span>}
        {right}
      </div>
    )}
  </div>
);

/** Segmented control (keyboard-navigable via Tabs). items: [{ value, label, count, testId }] */
export const Segmented = ({ value, onChange, items = [], className, testId = "admin-segmented", size = "md" }) => (
  <Tabs value={value} onValueChange={onChange} className={className}>
    <TabsList className={cn("h-auto flex-wrap justify-start gap-0.5 rounded-full bg-foreground/[0.06] p-0.5", size === "sm" && "gap-0")} data-testid={testId}>
      {items.map((it) => (
        <TabsTrigger key={it.value} value={it.value} className={cn("rounded-full px-3 text-[13px] transition-[background-color,color,box-shadow] data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-[0_1px_2px_hsl(var(--foreground)/0.08),0_0_0_1px_hsl(var(--foreground)/0.05)]", size === "sm" ? "h-7 px-2.5 text-[12.5px]" : "h-8")} data-testid={it.testId || `${testId}-${it.value}`}>
          {it.label}{it.count !== undefined && it.count !== null && <span className="ml-1.5 text-muted-foreground tabular">{it.count}</span>}
        </TabsTrigger>
      ))}
    </TabsList>
  </Tabs>
);
